import type { TOC } from '@ember/component/template-only';
import { Illustration } from 'frontend-utils';
import GeneralButtonsOtbSelfServiceButton from 'lumen/components/general/buttons/otb-self-service-button';
import GeneralEmptyStateDataValidation from 'lumen/components/general/empty-state-data-validation';
import hasFeature from 'lumen/helpers/has-feature';
import type {
  OTBSSEntryPoint,
  OTBSSViaQPValue,
} from 'lumen/utils/constants/otb-selfservice-constants';

import styles from './empty-state-occupancy.module.css';

interface GeneralEmptyStateOccupancySignature {
  Args: {
    imgHtml: string;
    otbSelfServiceEntryPoint: OTBSSEntryPoint;
    otbSelfServiceEntryProduct: OTBSSViaQPValue;
    stateDescription: string;
    stateTitle: string;
  };
}

const GeneralEmptyStateOccupancy = <template>
  {{#if (hasFeature "otb.empty_placeholder")}}
    <div class={{styles.container}}>
      <div class={{styles.content}}>
        <Illustration @html={{@imgHtml}} class={{styles.illustration}} />

        <div class={{styles.title-and-description}}>
          <span class={{styles.title}}>{{@stateTitle}}</span>

          <span>{{@stateDescription}}</span>

          <div class={{styles.self-service-button}}>
            <GeneralButtonsOtbSelfServiceButton
              @otbSelfServiceEntryPoint={{@otbSelfServiceEntryPoint}}
              @otbSelfServiceEntryProduct={{@otbSelfServiceEntryProduct}}
            />
          </div>
        </div>
      </div>
    </div>
  {{else}}
    <GeneralEmptyStateDataValidation />
  {{/if}}
</template> satisfies TOC<GeneralEmptyStateOccupancySignature>;

export default GeneralEmptyStateOccupancy;
